var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShown)?_c('div',{class:`alert-${_vm.alert.variant} fd-alert`,attrs:{"role":"alert"}},[_c('header',[_c('span',[_vm._v(_vm._s(_vm.alert.title || _vm.$gettext('Alert')))]),_c('button',{staticClass:"no-style-button",on:{"click":_vm.hide}},[_vm._v("⨯")])]),_c('p',[_c('span',[_vm._v(_vm._s(_vm.alert.content))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }